import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContentDocument } from '../types';
import { NerdyTipCallout } from './lib/nerdy-tip';

export function NerdyTip({ props }: NodeProps<{ children: StructuredContentDocument[] }>) {
  if (!props) return null;

  return (
    <NerdyTipCallout>
      {props.children?.map((child, index) => (
        <StructuredContentRenderer key={index} doc={child} />
      ))}
    </NerdyTipCallout>
  );
}
